export const DELETE_PROJECT_TEAM_MEMBER_ATTEMPT = 'DELETE_PROJECT_TEAM_MEMBER_ATTEMPT';
export type DELETE_PROJECT_TEAM_MEMBER_ATTEMPT = typeof DELETE_PROJECT_TEAM_MEMBER_ATTEMPT;

export const DELETE_PROJECT_TEAM_MEMBER_SUCCESS = 'DELETE_PROJECT_TEAM_MEMBER_SUCCESS';
export type DELETE_PROJECT_TEAM_MEMBER_SUCCESS = typeof DELETE_PROJECT_TEAM_MEMBER_SUCCESS;

export const DELETE_PROJECT_TEAM_MEMBER_FAILURE = 'DELETE_PROJECT_TEAM_MEMBER_FAILURE';
export type DELETE_PROJECT_TEAM_MEMBER_FAILURE = typeof DELETE_PROJECT_TEAM_MEMBER_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/project/team-member/delete/Types.tsx